import { render, staticRenderFns } from "./Compromisos.vue?vue&type=template&id=23904619&scoped=true&"
import script from "./Compromisos.vue?vue&type=script&lang=js&"
export * from "./Compromisos.vue?vue&type=script&lang=js&"
import style0 from "./Compromisos.vue?vue&type=style&index=0&id=23904619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23904619",
  null
  
)

export default component.exports